import { SIGN_IN_MODAL_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import DareDropIcon from 'root/src/client/public/icons/DareDropIcon'
import { faGoogle } from '@fortawesome/free-brands-svg-icons/faGoogle'
import { faTwitch } from '@fortawesome/free-brands-svg-icons/faTwitch'
import { faTiktok } from '@fortawesome/free-brands-svg-icons/faTiktok'
import login from 'root/src/client/logic/auth/thunks/login'
import loginSchema from 'root/src/shared/descriptions/formSchemas/loginSchema'
import loginWith from 'root/src/client/logic/auth/thunks/loginWith'
import providers from 'root/src/shared/constants/providers'
import { registerTerms } from 'root/src/shared/descriptions/modules/signUpModal'

export default {
	[SIGN_IN_MODAL_MODULE_ID]: {
		moduleType: 'modal',
		schema: loginSchema,
		modalContent: {
			title: 'Sign In',
			buttons: [
				{
					label: 'Sign In',
					icon: DareDropIcon,
					type: 'primary',
					iconSize: 25,
					onClick: login,
					htmlType: 'submit',
				},
				{
					label: 'Sign in with Twitch',
					icon: faTwitch,
					type: 'social',
					iconSize: 20,
					onClick: state => loginWith(providers.twitch)(state),
				},
				{
					label: 'Sign in with Google',
					icon: faGoogle,
					type: 'social',
					iconSize: 20,
					onClick: state => loginWith(providers.google)(state),
				},
				{
					label: 'Sign in with TikTok',
					icon: faTiktok,
					type: 'social',
					iconSize: 20,
					onClick: state => loginWith(providers.tiktok)(state),
				},
			],
			registerTerms,
		},
	},
}
